<script setup>
import {ClientJS} from "clientjs";
import {computed, inject, onMounted, ref} from "vue";
import {nextTick} from "alpinejs/src/nextTick";

// URL
const siteUrl = document.querySelector('meta[name="site-url"]').content;

// コラム ID
const id = inject('id');

// 表示数
const empathy = ref('');

// 現在自身が共感しているか
const active = ref(false);

// 連打防止用のロック
const lock = ref(false);
/**/
// 実際の共感数
const realEmpathyCount = computed(() => {
  return empathy.value === '' ? '0' : new Intl.NumberFormat().format(Number(empathy.value) + (active.value ? 1 : 0));
});

// 共感の変更を行う
const changeFavorite = async () => {
  // ロック中は処理を行わない
  if (lock.value) {
    return;
  }

  // ロックを設定
  lock.value = true;

  // この時点の active の値を保持
  const activeValue = active.value;

  //サーバーと通信を試みる
  try {
    //サーバーと適切なメソッドで通知を行う
    const response = await fetch(siteUrl+'writing/toggleEmpathy/'+id+'?fingerprint='+(new ClientJS()).getFingerprint());

    //レスポンス異常発生
    if ( ! response.ok) {
      //もし 404 だったらログインしていない
      if (response.status === 404) {
        throw new Error('ログインセッションが切れている可能性があります。恐れ入りますがページをリロードして再度ログインしてください。');
      }

      //エラーメッセージが返っているか判定
      const parameter = await response.json();

      //もしエラーメッセージが存在すれば返す
      if ('messages' in parameter && Array.isArray(parameter.messages)) {
        throw parameter.messages;
      }

      //エラーメッセージを文字列に変換して例外を投げる
      throw new Error('エラーが発生しました。しばらくしてから再度お試しください。');
    }

    // 応答 JSON のパース
    const data = await response.json();

    // data.empathy が true なら +1、false なら -1
    active.value = data.empathy;
  }

    //エラーが起きたら文字列の一次元配列に成形して errors に登録する
  catch (error) {
    //恐らく通信途絶
    if (error instanceof TypeError) {
      console.log('ネットワーク接続に失敗しました。');
    }

    //恐らく意図的な中断
    else if (error instanceof DOMException) {
      console.log('ネットワーク接続が中断されました。');
    }

    //恐らくサーバーからのメッセージ
    else if (Array.isArray(error)) {
      console.log(error.join("\n"));
    }

    //恐らくカスタムエラー
    else if (error instanceof Error) {
      console.log(error.message);
    }

    //不明
    else {
      console.log('エラーが発生しました。しばらくしてから再度お試しください。');
    }

    // エラーが発生した場合は、active の値を元に戻す
    active.value = ! active.value;
  }

  finally {
    // ロックを解除
    lock.value = false;
  }
};

// サーバーから共感数を取得
onMounted(() => {
  const init = async () => {
    try {
      // まずは localStorage から値を取得
      const storedData = localStorage.getItem('writing-get-empathy'+id);

      // localStorage に保存された値が存在し、かつ保存された時間から 5 分以内であれば、その値を使用
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        const currentTime = Date.now();
        if (currentTime - parsedData.timestamp < 5 * 60 * 1000) {
          empathy.value = String(parsedData.count);
          active.value = parsedData.result;
          empathy.value = active.value ? empathy.value - 1 : empathy.value;
          return;
        }
      }

      // サーバーと通信
      const response = await fetch(siteUrl+'writing/getEmpathy/'+id+'?fingerprint='+(new ClientJS()).getFingerprint());

      // レスポンス異常発生
      if ( ! response.ok) {
        return;
      }

      // レスポンスを取得
      const data = await response.json();

      // 各値を localStorage に保存
      localStorage.setItem('writing-get-empathy'+id, JSON.stringify({
        count: data.count,
        result: data.result,
        timestamp: Date.now()
      }));

      // 各値を設定
      empathy.value = String(data.count);
      active.value = data.result;
      empathy.value = active.value ? empathy.value - 1 : empathy.value;
    }

    catch (error) {
      console.log(error.message);
    }
  };

  setTimeout(init, 20);
});
</script>

<template>
  <label class="pChip dHeart dRed">
    <input
      v-model="active"
      type="checkbox"
      @change="changeFavorite"
    >
    <span class="pFont14 pFontMedium">{{realEmpathyCount}}</span>
  </label>
</template>
